import SidebarDashboardSupervisor from "../../components/sidebars/SidebarDashboardSupervisor"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"
export default function DataDictionaries() {
  return (
    <>
      <PageSidebarContent>
        <SidebarDashboardSupervisor />
      </PageSidebarContent>
      <div className="my-dashboard-wrapper">
        <h1>Data Dictionaries</h1>
      </div>
    </>
  )
}
